import React, { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import PublicLayout from '../layouts/PublicLayout.jsx'
import SkeletonSection from '../components/common/SkeletonSection.jsx'

import HomePage from '../pages/public/Home/HomePage.jsx'
import ServicesPage from '../pages/public/Services/ServicesPage.jsx'
import ServiceDetailPage from '../pages/public/Services/ServiceDetail/ServiceDetailPage.jsx'
import IndustriesPage from '../pages/public/Industries/IndustriesPage.jsx'
import IndustryDetailPage from '../pages/public/Industries/IndustryDetail/IndustryDetailPage.jsx'
import ContactPage from '../pages/public/Contact/ContactPage.jsx'
import AboutPage from '../pages/public/About/AboutPage.jsx'
import CareersPage from '../pages/public/Careers/CareersPage.jsx'
import CareerDetailPage from '../pages/public/Careers/CareerDetail/CareerDetailPage.jsx'
import WebinarsPage from '../pages/public/Webinars/WebinarsPage.jsx'
import WebinarDetailPage from '../pages/public/Webinars/WebinarDetail/WebinarDetailPage.jsx'
import BlogsPage from '../pages/public/Blogs/BlogsPage.jsx'
import BlogDetailPage from '../pages/public/Blogs/BlogDetail/BlogDetailPage.jsx'
import CaseStudiesPage from '../pages/public/CaseStudies/CaseStudiesPage.jsx'
import CaseStudyDetailPage from '../pages/public/CaseStudies/CaseStudyDetail/CaseStudyDetailPage.jsx'
import NotFoundPage from '../pages/public/NotFound/NotFoundPage.jsx'
import TermsAndConditions from '../pages/public/TermsAndConditions/TermsAndConditions.jsx'
import Privacy from '../pages/public/Privacy/Privacy.jsx'
import Cookies from '../pages/public/Cookies/Cookies.jsx'


export default function PublicRoutes() {
    return (
        <Suspense fallback={<SkeletonSection />}>
            <Routes>
                {/* Public Layout Route Wrapper */}
                <Route element={<PublicLayout />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/services/:slug" element={<ServiceDetailPage />} />
                    <Route path="/industries" element={<IndustriesPage />} />
                    <Route path="/industries/:slug" element={<IndustryDetailPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="/careers/:slug" element={<CareerDetailPage />} />

                    {/* Additional Routes For Carerrs */}
                    <Route path="/career" element={<CareersPage />} />
                    <Route path="/job-opening" element={<CareersPage />} />

                    <Route path="/webinars" element={<WebinarsPage />} />
                    <Route path="/webinars/:slug" element={<WebinarDetailPage />} />
                    <Route path="/blogs" element={<BlogsPage />} />
                    <Route path="/blog/:slug" element={<BlogDetailPage />} />
                    <Route path="/case-studies" element={<CaseStudiesPage />} />
                    <Route path="/terms" element={<TermsAndConditions />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/cookies" element={<Cookies />} />
                    <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Routes>
        </Suspense>
    )
}
